export default __webpack_public_path__ + "static/media/no_image.d6a64ff8.png";